



























import { Component, Vue } from "vue-property-decorator";
import { deletePlayer } from "@/services/players/playerService";

@Component
export default class PlayerDeleteModal extends Vue {
    playerToBeDeleted: string = "";
    playerName: string = ""
    isSaved: boolean = false;

    handleEnter(e: KeyboardEvent) {
        if (e.key === "Enter") this.confirm();
    }

    removeEvent() {
        window.removeEventListener("keydown", this.handleEnter);
        this.isSaved = false;
    }

    open(playerId: string, name: string) {
        this.playerToBeDeleted = playerId;
        this.playerName = name;
        this.$bvModal.show("modal-deletePlayer");
        window.addEventListener("keydown", this.handleEnter);
    }

    decline() {
        this.$bvModal.hide("modal-deletePlayer");
        this.playerName = "";
        this.playerToBeDeleted = "";
    }

    confirm() {
        if (this.isSaved) return;
        this.isSaved = true;
        deletePlayer(this.playerToBeDeleted).then(() => {
            this.$emit("reload");
            this.playerName = "";
            this.playerToBeDeleted = "";
            this.$bvModal.hide("modal-deletePlayer");
        });
    }
}
